import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiAward, FiCompass, FiNavigation, FiCrown} = FiIcons;

const MasterPath = () => {
  const wisdoms = [
    {
      icon: FiAward,
      title: '"ความมั่นใจที่หยั่งรากลึก"',
      description: 'กลับมาเชื่อมั่นในทุกการตัดสินใจอีกครั้ง โดยมีข้อมูลจากผัง Bazi เป็นเครื่องยืนยัน ไม่ว่าจะเป็นการลงทุน,การส่งต่อธุรกิจ,หรือการวางแผนชีวิตในบทต่อไป'
    },
    {
      icon: FiNavigation,
      title: '"ศิลปะแห่งการนำทาง"',
      description: 'เข้าใจกระแสขึ้นลงของชีวิต ทำให้คุณสามารถนำทางในช่วงเวลาแห่งความไม่แน่นอนได้อย่างสง่างามและเป็นสุข'
    },
    {
      icon: FiCrown,
      title: '"ปัญญาในการเดินเกม"',
      description: 'เปลี่ยนประสบการณ์ให้กลายเป็นบารมี ผสานกับความเข้าใจในศาสตร์ ปาจื้อ เพื่อสร้างมรดกและความสำเร็จที่ยั่งยืนอย่างแท้จริง'
    }
  ];

  return (
    <section className="py-20 relative" id="master">
      <div className="absolute inset-0 bg-gradient-to-b from-indigo-900/10 via-purple-900/20 to-slate-900"></div>
      
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.8}}
          viewport={{once: true}}
        >
          <div className="flex items-center justify-center mb-8">
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-r from-indigo-500 to-purple-500 flex items-center justify-center mr-4">
              <SafeIcon icon={FiCompass} className="w-8 h-8 text-white" />
            </div>
            <div className="text-left">
              <h2 className="text-4xl md:text-5xl font-light text-white">นำทางชีวิตด้วยความมั่นใจจาก Bazi</h2>
            </div>
          </div>
          <div className="bg-gradient-to-r from-indigo-900/30 to-purple-900/30 rounded-2xl p-8 mb-12 border border-indigo-500/20 backdrop-blur-sm">
            <p className="text-2xl text-indigo-100 font-light italic">
              "ทำอย่างไรจึงจะเดินเกมชีวิตในช่วงต่อไปได้อย่างสง่างามและผิดพลาดน้อยที่สุด?"
            </p>
          </div>
        </motion.div>

        <motion.div
          className="bg-white/5 backdrop-blur-lg rounded-3xl p-10 border border-white/10 mb-12"
          initial={{opacity: 0, scale: 0.9}}
          whileInView={{opacity: 1, scale: 1}}
          transition={{duration: 0.8}}
          viewport={{once: true}}
        >
          <p className="text-lg text-slate-300 leading-relaxed font-light mb-8">
            คุณเดินทางผ่านร้อนผ่านหนาวมานับครั้งไม่ถ้วน ชัยชนะและบาดแผลได้หล่อหลอมให้คุณเป็นคุณในวันนี้ แต่ลึกๆ แล้ว คุณรู้ว่าพลังที่แท้จริงไม่ใช่การต่อสู้อีกต่อไป... แต่คือ <span className="text-indigo-400 font-medium">"ความเข้าใจอย่างถ่องแท้"</span>
          </p>
          <p className="text-lg text-slate-300 leading-relaxed font-light">
            คุณไม่ต้องการความเหนื่อยล้าจากการไล่ตามที่ไม่สิ้นสุด แต่ปรารถนาความสงบ ความมั่นคง และความมั่นใจ ศาสตร์แห่ง <span className="text-purple-400 font-medium">ปาจื้อ (八字,Bazi)</span> คือ <span className="text-indigo-400 font-medium">"เข็มทิศแห่งปรมาจารย์"</span> ที่จะมอบ:
          </p>
        </motion.div>

        <div className="space-y-8 mb-12">
          {wisdoms.map((wisdom, index) => (
            <motion.div
              key={index}
              className="bg-gradient-to-r from-white/5 to-white/10 backdrop-blur-lg rounded-2xl p-8 border border-white/10"
              initial={{opacity: 0, x: index % 2 === 0 ? -50 : 50}}
              whileInView={{opacity: 1, x: 0}}
              transition={{duration: 0.8, delay: index * 0.2}}
              viewport={{once: true}}
            >
              <div className="flex items-start space-x-6">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-indigo-500 to-purple-500 flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={wisdom.icon} className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h4 className="text-xl text-white font-light mb-3">{wisdom.title}</h4>
                  <p className="text-slate-300 leading-relaxed font-light">{wisdom.description}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Testimonial */}
        <motion.div
          className="bg-gradient-to-r from-indigo-900/20 to-purple-900/20 rounded-3xl p-10 border border-indigo-500/20 backdrop-blur-sm text-center"
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.8, delay: 0.5}}
          viewport={{once: true}}
        >
          <div className="mb-6">
            <div className="w-16 h-16 rounded-full bg-gradient-to-r from-indigo-500 to-purple-500 flex items-center justify-center mx-auto mb-4">
              <span className="text-white font-light text-2xl">อ</span>
            </div>
          </div>
          <blockquote className="text-xl text-indigo-100 italic font-light leading-relaxed mb-6">
            "พออายุเท่านี้ เราไม่ได้มองหาแค่กำไร แต่มองหาความสบายใจ คอร์ส Bazi นี้ให้สิ่งนั้นครับ มันทำให้รู้ว่าเมื่อไหร่ควรหยุด เมื่อไหร่ควรไปต่อ มันคือการบริหารชีวิต ไม่ใช่แค่บริหารพอร์ต"
          </blockquote>
          <cite className="text-indigo-300 font-light">
            — อนันต์,Fulltime Trader
          </cite>
        </motion.div>
      </div>
    </section>
  );
};

export default MasterPath;